import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';

import * as Sentry from '@sentry/angular';

export const IGNORE_ERROR = new HttpContextToken(() => false);

@Injectable()
export class InternalServerErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === HttpStatusCode.InternalServerError) {
            // This is to properly log RudderStack header errors. Realistically not a backend error,
            // since header shouldn't be over 7000 characters long
            const rsHeaderLength =
              request.headers.getAll('rs-anonymous-id')?.join('').length ?? 0;
            if (rsHeaderLength > 6500) {
              Sentry.captureException(
                `[RudderStack ERROR] Header 'rs-anonymous-id' is too long; ${rsHeaderLength} characters`
              );
            }
            // This is so API call can skip this interceptor.
            // Recommended when subscriber handles error
            if (
              !request.context.get(IGNORE_ERROR) &&
              !this.router.url.startsWith('/error/general')
            ) {
              this.router.navigate(['/error/general'], {
                replaceUrl: true,
                queryParams: { returnUrl: this.router.url },
              });
              return EMPTY;
            }
          }
        }
        return throwError(() => error);
      })
    );
  }
}
